<!--
 * @Descripttion: 
 * @version: 
 * @Author: yuhongyou
 * @Date: 2021-10-18 09:05:26
 * @LastEditors: yuhongyou
 * @LastEditTime: 2021-11-26 09:50:58
-->
<template>
  <div :id="chartId" :style="{'width':'100%', 'height':'100%'}"></div>
</template>

<script>
import * as echarts from 'echarts'
// import 'echarts-liquidfill'
export default {
  props:{
    chartId: {
      type: String,
      default: 'echart'
    },
    chartOption: {
      type: Object,
      default: ()=>{
        return {}
      }
    },
  },
  computed:{
    screenData() {
      return this.$store.state.screen;
    },
  },
  watch:{
    chartOption: {
      handler(newVal, oldVal) {
        this.echartOptions = newVal
        this.drawEchart()
      },
      deep: true //对象内部属性的监听，关键。
    },
    screenData() {
      this.chart.resize();
    },
  },
  data(){
    return{
      echartOptions:{},
      chart: null
    }
  },
  mounted (){
    this.$nextTick(()=>{
      this.echartOptions = this.chartOption
      this.drawEchart()
    })
  },
  methods:{
    drawEchart(){
      // let legendIconWidth = document.body.clientWidth > 1280 ? (document.body.clientWidth > 1440 ? 14 : (document.body.clientWidth > 1680 ? 16 : 14)) : 12
      // 基于准备好的dom，初始化echarts实例
      // console.log(echarts)
      let myChart = echarts.init(document.getElementById(this.chartId))
      this.chart = myChart
      // if(this.echartOptions.legend){
      //   this.echartOptions.legend.itemWidth = legendIconWidth
      //   this.echartOptions.legend.itemHeight = legendIconWidth
      // }
      // 绘制图表
      // window.onresize = function() {
      //   myChart.resize();
      // }
      myChart.setOption(this.echartOptions);
    }
  }
}
</script>

<style lang="scss" scoped>

</style>

